var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"flex gap-4 border-b border-slate-200 dark:border-slate-700"},[_c('router-link',{staticClass:"pb-2 text-sm font-medium border-b-2",class:!_vm.isAgentsTab && !_vm.isCalendarTab
        ? 'border-woot-500 text-woot-600 dark:text-woot-400'
        : 'border-transparent text-slate-500 dark:text-slate-400',attrs:{"to":{
      name: 'real_estate',
      params: { accountId: _vm.$route.params.accountId },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t('REAL_ESTATE.TABS.PROJECTS'))+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"pb-2 text-sm font-medium border-b-2",class:_vm.isAgentsTab
        ? 'border-woot-500 text-woot-600 dark:text-woot-400'
        : 'border-transparent text-slate-500 dark:text-slate-400',attrs:{"to":{
      name: 'real_estate_agents',
      params: { accountId: _vm.$route.params.accountId },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t('REAL_ESTATE.TABS.AGENTS'))+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"pb-2 text-sm font-medium border-b-2",class:_vm.isCalendarTab
        ? 'border-woot-500 text-woot-600 dark:text-woot-400'
        : 'border-transparent text-slate-500 dark:text-slate-400',attrs:{"to":{
      name: 'real_estate_calendar',
      params: { accountId: _vm.$route.params.accountId },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t('REAL_ESTATE.TABS.CALENDAR'))+"\n  ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }